// extracted by mini-css-extract-plugin
export default {"label":"YLpT_aof_xKbux4cJguz","size-lg":"JMWHON5XcUcbC6zxwcr_"};